import React, { useState } from 'react'
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image'
import { RightArrow } from 'components/Icons/Icons'
import * as SliderIcons from 'components/Icons/Icons'
import * as ProductIcons from 'components/ProductIcons'
import * as NotProductIcons from 'components/NotProductIcons'
import Link from 'components/Link'
import { motion } from 'framer-motion'
import SliderComponent from 'react-slick'
import { prepareData } from 'utils/googleData'

const Title = ({ title }) => {
    return <h3 className="mb-0 text-lg lg:mt-5 lg:text-3xl">{title}</h3>
}

const Subtitle = ({ subtitle, className = '' }) => {
    return <h4 className={`mb-3 text-[18px] font-semibold leading-tight opacity-70 ${className}`}>{subtitle}</h4>
}

const Description = ({ description, className = '' }) => {
    return <p className={`m-0 text-[16px] leading-tight opacity-70 ${className}`}>{description}</p>
}
const Subdescription = ({ subDescription, className = '' }) => {
    return <p className={`m-0 text-[13px] leading-tight opacity-70 ${className}`}>{subDescription}</p>
}

const CTA = ({ url, title }) => {
    return (
        <Link className="group mt-4 flex items-center space-x-1 text-[15px] font-bold" to={url}>
            <span>{title}</span>
            <span className="text-gray-accent-light">
                <RightArrow className="bounce w-[20px]" />
            </span>
        </Link>
    )
}

const ContentContainer = ({ children, className = '' }) => {
    return <div className={`order-1 flex flex-col md:order-2 ${className}`}>{children}</div>
}

const SliderContainer = ({ children, className = '' }) => {
    return <div className={`relative grid grid-cols-2 gap-7 pt-5 ${className}`}>{children}</div>
}
const Content = ({ children, className = '' }) => {
    return <div className={`max-w-[450px] pl-5 pb-5 md:py-0 md:px-0 ${className}`}>{children}</div>
}

const ImageContainer = ({ children, className = '' }) => {
    return <div className={`relative order-2 h-[300px] md:order-1 xl:h-[400px] ${className}`}>{children}</div>
}

export const SlideButton = ({ name, icon, activeSlide, index }) => {
    const active = activeSlide === index
    const Icon = SliderIcons[icon] || NotProductIcons[icon] || ProductIcons[icon]
    return (
        <li className="p-1">
            <button
                className={`relative flex h-full w-full flex-col items-center justify-center space-y-2 rounded-md px-1 pt-1 pb-3 transition-opacity transition-colors hover:bg-gray-accent/25 focus:bg-gray-accent/40 active:top-[1px] active:scale-[.99] md:space-y-0 ${
                    active ? 'active bg-gray-accent/40 hover:bg-gray-accent/40 ' : 'group '
                }`}
            >
                <span className="flex h-[52px] w-[52px] items-center justify-center opacity-60 group-hover:opacity-90">
                    <span className="absolute">
                        <Icon active={active} />
                    </span>
                </span>
                <p
                    className={`lg:text-md m-0 -mt-2 text-sm leading-tight opacity-90 ${
                        active ? 'font-bold' : 'font-semibold'
                    }`}
                >
                    {name}
                </p>
            </button>
        </li>
    )
}

export default function Slider(props) {
    const result = prepareData({ props })
    const { enable, title, subtitle, description, cta, direction, style, gatsbyImage, sections, gatsbyImage2 } = result
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    let products = result?.products
    products = products.filter((product) => {
        return product?.enable?.toLowerCase?.() !== 'false' || process.env.RENDER_DISABLED_COMPONENTS
    })
    const [buttonRef, setButtonRef] = useState()
    const [slideRef, setSlideRef] = useState()
    const [activeSlide, setActiveSlide] = useState(0)
    const [lazyLoad, setLazyLoad] = useState()

    const handleButtonChange = (_oldIndex, newIndex) => {
        setActiveSlide(newIndex)
    }

    const handleDropdownChange = (e) => {
        slideRef.slickGoTo(e.target.selectedIndex)
    }

    return (
        <div>
            <div className="-mt-8 border-b border-dashed border-gray-accent-light md:mt-0 md:border-t">
                <div className="hidden border-b border-dashed border-gray-accent-light md:block">
                    <SliderComponent
                        beforeChange={handleButtonChange}
                        ref={(buttonRef) => setButtonRef(buttonRef)}
                        asNavFor={slideRef}
                        arrows={false}
                        slidesToShow={products?.length}
                        focusOnSelect
                        className="home-slider-buttons m-0 mx-auto max-w-full list-none border-r border-l border-dashed border-gray-accent-light p-0 lg:max-w-4xl xl:max-w-5xl 2xl:max-w-7xl"
                    >
                        {products?.length > 0 &&
                            products.map((product, index) => {
                                if (
                                    product?.enable?.toLowerCase?.() === 'false' &&
                                    !process.env.RENDER_DISABLED_COMPONENTS
                                ) {
                                    return <></>
                                }
                                let productsTitle = product?.productsTitle
                                if (Array.isArray(productsTitle) && productsTitle.length == 1)
                                    productsTitle = productsTitle[0]
                                return (
                                    <SlideButton
                                        index={index}
                                        activeSlide={activeSlide}
                                        key={productsTitle?.title}
                                        name={productsTitle?.title}
                                        icon={productsTitle?.icon}
                                    />
                                )
                            })}
                    </SliderComponent>
                </div>
                <div className="block px-4 md:hidden">
                    <p className="mt-0 text-center text-[14px] opacity-50">{title}</p>
                    <div className="relative">
                        <select
                            value={activeSlide}
                            onChange={handleDropdownChange}
                            className="text-md block w-full appearance-none rounded bg-white p-3 text-center font-bold shadow-lg"
                        >
                            {products?.length > 0 &&
                                products.map((product, index) => {
                                    if (
                                        product?.enable?.toLowerCase?.() === 'false' &&
                                        !process.env.RENDER_DISABLED_COMPONENTS
                                    ) {
                                        return <></>
                                    }
                                    let productsTitle = product?.productsTitle
                                    if (Array.isArray(productsTitle) && productsTitle.length == 1)
                                        productsTitle = productsTitle[0]
                                    return (
                                        <option value={index} key={index}>
                                            {productsTitle?.title}
                                        </option>
                                    )
                                })}
                        </select>
                        <svg
                            className="absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g opacity="0.3">
                                <path
                                    d="M10.4016 3.98684L6.99792 7.39165L3.59424 3.98684C3.13815 3.53075 2.39931 3.53075 1.94322 3.98684C1.48768 4.44239 1.48768 5.18177 1.94322 5.63731L6.17276 9.86685C6.62831 10.3218 7.36658 10.3218 7.8221 9.86685L12.0511 5.63787C12.5072 5.18232 12.5072 4.4435 12.0516 3.98742C11.5961 3.53134 10.8577 3.5313 10.4016 3.98684Z"
                                    fill="black"
                                />
                            </g>
                        </svg>
                    </div>
                </div>
                <div className="flex items-center">
                    <div className="hidden flex-grow items-center justify-center md:absolute md:left-2 md:flex xl:static">
                        <button
                            onClick={() => slideRef.slickPrev()}
                            className="relative rounded-sm bg-white px-3 py-2  shadow-md active:top-[1px] active:scale-[.97] md:z-30"
                        >
                            <RightArrow className="w-5 rotate-180" />
                        </button>
                    </div>
                    <SliderComponent
                        adaptiveHeight
                        onInit={() => setLazyLoad('ondemand')}
                        lazyLoad={lazyLoad}
                        ref={(slideRef) => setSlideRef(slideRef)}
                        asNavFor={buttonRef}
                        arrows={false}
                        slidesToShow={1}
                        infinite
                        className="home-slider divide m-0 mx-auto flex w-full max-w-full flex-shrink-0 list-none items-center justify-center divide-x divide-dashed divide-gray-accent-light overflow-auto border-dashed border-gray-accent-light p-0 md:border-l md:border-r lg:max-w-4xl xl:max-w-5xl 2xl:max-w-7xl"
                    >
                        {products?.length > 0 &&
                            products.map((product, index) => {
                                if (
                                    product?.enable?.toLowerCase?.() === 'false' &&
                                    !process.env.RENDER_DISABLED_COMPONENTS
                                ) {
                                    return <></>
                                }
                                const productsTitle = product?.productsTitle
                                const cta = product?.cta
                                const featuresGroups = product?.featuresGroups
                                // if (Array.isArray(featuresGroups) && featuresGroups.length == 1) featuresGroups = featuresGroups[0]
                                // if (Array.isArray(img) && img.length == 1) img = img[0]
                                const footers = product?.footers
                                // if (Array.isArray(footers) && footers.length == 1) footers = footers[0]
                                return (
                                    <SliderContainer key={index}>
                                        <ImageContainer className="-ml-8 h-[40vw] md:-ml-0 md:h-[300px] xl:h-[400px]">
                                            <motion.div
                                                transition={{ delay: 0.4 }}
                                                className="h-full"
                                                initial={{ translateY: '100%' }}
                                                animate={{ translateY: 0 }}
                                            >
                                                {product.gatsbyImage && (
                                                    <GatsbyImage
                                                        imageStyle={{
                                                            objectFit: `contain`,
                                                            objectPosition: `top left`,
                                                        }}
                                                        className="h-full w-[200%] max-w-[907.5px] rotate-2 shadow-xl md:w-full"
                                                        // className="w-full h-full"
                                                        placeholder="none"
                                                        quality={100}
                                                        image={product.gatsbyImage}
                                                        alt="A code snippet to check if the real estate marketing 'nav' is enabled"
                                                    />
                                                )}
                                            </motion.div>
                                        </ImageContainer>
                                        <ContentContainer>
                                            <Content>
                                                <Title title={productsTitle?.title} />
                                                <Subtitle
                                                    className="text-[14px] md:text-[18px]"
                                                    subtitle={productsTitle?.subtitle}
                                                />
                                                {featuresGroups.map((featuresGroup, index2) => {
                                                    if (
                                                        featuresGroup?.enable?.toLowerCase?.() === 'false' &&
                                                        !process.env.RENDER_DISABLED_COMPONENTS
                                                    ) {
                                                        return <></>
                                                    }
                                                    return (
                                                        <>
                                                            <Subdescription
                                                                subDescription={featuresGroup?.description}
                                                                key={index2}
                                                            />
                                                            <ul
                                                                key={index2}
                                                                className="home-marketing-center-propertymanagement-features m-0 mr-8 grid list-none p-0 md:grid-cols-3 lg:mt-2 lg:mr-3"
                                                            >
                                                                {featuresGroup?.features?.map((feature, index3) => {
                                                                    if (
                                                                        feature?.enable?.toLowerCase?.() === 'false' &&
                                                                        !process.env.RENDER_DISABLED_COMPONENTS
                                                                    ) {
                                                                        return <></>
                                                                    }
                                                                    const Icon =
                                                                        SliderIcons[feature?.icon] ||
                                                                        NotProductIcons[feature?.icon] ||
                                                                        ProductIcons[feature?.icon]
                                                                    return (
                                                                        <>
                                                                            {feature?.title && (
                                                                                <li
                                                                                    key={feature?.title}
                                                                                    className="p-[1px]"
                                                                                >
                                                                                    {feature?.url && (
                                                                                        <Link
                                                                                            to={feature?.url}
                                                                                            key={index3}
                                                                                            className="flex items-center space-x-2 rounded border-b border-dashed border-gray-accent-light py-1 px-1 text-[10px] transition-all hover:bg-gray-accent/25 hover:bg-gray-accent-light focus:bg-gray-accent/40 md:border-b-0 md:py-2 lg:text-[11px] xl:px-1"
                                                                                        >
                                                                                            {Icon && (
                                                                                                <span>
                                                                                                    <Icon
                                                                                                        className={` w-[20px]`}
                                                                                                        key={index3}
                                                                                                    />
                                                                                                </span>
                                                                                            )}
                                                                                            <span
                                                                                                className="opacity-70"
                                                                                                key={index3}
                                                                                            >
                                                                                                {feature?.title}
                                                                                            </span>
                                                                                        </Link>
                                                                                    )}
                                                                                </li>
                                                                            )}
                                                                        </>
                                                                    )
                                                                })}
                                                            </ul>
                                                        </>
                                                    )
                                                })}
                                                <CTA url={cta?.url} title={cta?.text} />
                                            </Content>
                                            {footers?.length > 0 && footers[0]?.title !== '' ? (
                                                <>
                                                    {footers?.map((footer, index3) => {
                                                        if (
                                                            footer?.enable?.toLowerCase?.() === 'false' &&
                                                            !process.env.RENDER_DISABLED_COMPONENTS
                                                        ) {
                                                            return <></>
                                                        }
                                                        return (
                                                            <div key={index3} className="mt-auto flex w-full items-end">
                                                                <div key={index3} className="mb-3 hidden md:block">
                                                                    <hr
                                                                        key={index3}
                                                                        className="h-[3px] w-[20px] rounded-full"
                                                                    />
                                                                    <div
                                                                        key={index3}
                                                                        className="inline-block text-[12px] leading-tight"
                                                                    >
                                                                        {footer?.title}{' '}
                                                                        {footer?.items?.map((item, index4) => {
                                                                            if (
                                                                                item?.enable?.toLowerCase?.() ===
                                                                                    'false' &&
                                                                                !process.env.RENDER_DISABLED_COMPONENTS
                                                                            ) {
                                                                                return <></>
                                                                            }
                                                                            return (
                                                                                <>
                                                                                    <Link key={index4} to={item?.url}>
                                                                                        {item?.name}
                                                                                    </Link>
                                                                                    {index4 !=
                                                                                        footer?.items?.length - 1 && (
                                                                                        <>, </>
                                                                                    )}
                                                                                </>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                </div>
                                                                {footer.gatsbyImage && (
                                                                    <div className="w-3/4 md:relative" key={index3}>
                                                                        <div
                                                                            className="absolute -bottom-2 right-0"
                                                                            key={index3}
                                                                        >
                                                                            <motion.div
                                                                                transition={{ delay: 0.5 }}
                                                                                initial={{ translateX: '100%' }}
                                                                                animate={{ translateX: 0 }}
                                                                                key={index3}
                                                                            >
                                                                                <GatsbyImage
                                                                                    placeholder="none"
                                                                                    quality={100}
                                                                                    className="w-full max-w-[215px] xl:max-w-[360px]"
                                                                                    image={footer.gatsbyImage}
                                                                                    key={index3}
                                                                                    alt=""
                                                                                />
                                                                            </motion.div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )
                                                    })}
                                                </>
                                            ) : (
                                                <>
                                                    {' '}
                                                    <div className="mt-auto flex w-full items-end "></div>{' '}
                                                </>
                                            )}
                                        </ContentContainer>
                                    </SliderContainer>
                                )
                            })}
                    </SliderComponent>
                    <div className="hidden flex-grow items-center justify-center md:absolute md:right-2 md:flex xl:static">
                        <button
                            onClick={() => slideRef.slickNext()}
                            className="relative rounded-sm bg-white px-3 py-2 shadow-md active:top-[1px] active:scale-[.97] md:z-30"
                        >
                            <RightArrow className="w-5" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
